// extracted by mini-css-extract-plugin
export default {"Frame":"App_Frame__gzvex"};